import ICasTableColumn from './ICasTableColumn';
import CasTable from './CasTable';
import getCasTableCellValue from './getCasTableCellValue';
import ICasRenderCellProps from './ICasRenderCellProps';
import { TRowSx } from './CasTableBody';

import defaultLabelFromField from '../../util/defaultLabelFromField';

const ROW_HEADER_1 = 'metricLabel';

interface ITransformedRow extends ICasTableColumn {
  [ROW_HEADER_1]: string;
  [key: string]: any;
}

interface Props {
  data: {
    result: {
      columnKey: string;
      [key: string]: any;
    }[];
  };
  columns: ICasTableColumn[];
  colSx?: TRowSx;
}

export default function CasTableRowsAsColumns({ columns: parmColumns, data: parmData, colSx }: Props) {
  const columns: any = [
    {
      render: ({ row }: ICasRenderCellProps) => row[ROW_HEADER_1],
      sx: (row: any, column: any) => (row.sx ? row.sx(row, column) : {}),
      align: 'center',
    },
    ...parmData.result.map((dataRow) => ({
      field: dataRow.columnKey,
      label: dataRow.columnKey,
      align: 'center',
      sx: (row: any, column: any) => {
        const rowStyle = row.sx ? row.sx(row, column) : {};
        const colStyle = colSx?.(dataRow) || {};
        return { ...colStyle, ...rowStyle };
      },
      render: ({ row, column }: ICasRenderCellProps) =>
        row.render ? row.render({ row, column }) : getCasTableCellValue({ row, column }),
    })),
  ];

  const data: ITransformedRow[] = parmColumns.map((metricCol) => {
    const newRow: ITransformedRow = {
      ...metricCol,
      [ROW_HEADER_1]: metricCol.label ?? defaultLabelFromField(metricCol.field),
    } as ITransformedRow;

    parmData.result.forEach((dataRow) => {
      newRow[dataRow.columnKey] = metricCol.field ? dataRow[metricCol.field] : undefined;
    });

    return newRow;
  });

  return <CasTable columns={columns} data={{ result: data }} />;
}
